<template>
	<div id="leftMenuPublic" class="w-100 bg-white border-15 shadow p-3 overflow-auto">
		<br/>
		<p class="text-success font-weight-bold">
			تماس با ما
		</p>
		<img :src="require('../assets/img/Logo_Footer.svg')" style="width:50%;" />
		<br/>
		<br/>
		<div>
			<img
				:src="require('../assets/img/phone-call.svg')"
				alt="تلفن : 021-88625168  021-88618512"
				title="تلفن : 021-88625168  021-88618512"
				width="16"
			/>
			تلفن:
		</div>
		<div class="text-left">
			021-88625168
		</div>
		<div class="text-left">
			021-88618512
		</div>
		<div>
			<img
				:src="require('../assets/img/mail.svg')"
				alt="ایمیل: info@ostadbin.com"
				title="ایمیل: info@ostadbin.com"
				width="16"
			/>
			ایمیل:
		</div>
		<div class="text-left">
			info@ostadbin.com
		</div>
		<div>
			<img
				:src="require('../assets/img/address.svg')"
				alt="آدرس شرکت:خیابان شیراز جنوبی، بلوار آقا علیخانی شرقی پلاک2 طبقه 2 فناوری رهنمای دنیای آینده (فردا)"
				title="آدرس شرکت:خیابان شیراز جنوبی، بلوار آقا علیخانی شرقی پلاک2 طبقه 2 فناوری رهنمای دنیای آینده (فردا)"
				width="16"
			/>
			آدرس شرکت:
		</div>
		<div class="text-justify">
			خیابان شیراز جنوبی، بلوار آقا علیخانی شرقی پلاک2 طبقه 2 فناوری رهنمای دنیای آینده (فردا)
		</div>


		<p class="text-orange text-justify" v-if="urlPath != ''">
			ایزی تیک با توجه به نیاز شما بهترین و مناسب ترین مدرس را به شما معرفی خواهد کرد.
		</p>
	</div>
</template>

	<script>
		import { indexFinder } from  "../assets/library/filter.js";
		export default {
			name: 'leftMenu',
			data(){
				return {
					indexFinder: indexFinder,
					index_0: -1,
					index_1: -1,
					index_2: -1,
					index_3: -1,
					index_4: -1,
					index_5: -1,
					index_6: -1,
					index_7: -1,
					index_8: -1,
					index_9: -1,
					settings: this.$localStorage.get('settings'),
				}
			},
			props: {
				urlPath:{
					default: ""
				},
			},
			components: {

			},
			mounted(){
				this.index_0 = this.indexFinder(this.settings, "1");
				this.index_1 = this.indexFinder(this.settings, "2");
				this.index_2 = this.indexFinder(this.settings, "4");
				this.index_3 = this.indexFinder(this.settings, "5");
				this.index_4 = this.indexFinder(this.settings, "6");
				this.index_5 = this.indexFinder(this.settings, "7");
				this.index_6 = this.indexFinder(this.settings, "8");
				this.index_7 = this.indexFinder(this.settings, "9");
				this.index_8 = this.indexFinder(this.settings, "10");
				this.index_9 = this.indexFinder(this.settings, "17");
			},
			methods:{

			}
		}
	</script>
<style>

</style>
